
import { Location } from '@angular/common';
import { Component, DoCheck, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticEvent } from 'app/lib/analytic-event';
import { ApiService } from 'app/lib/api.service';
import { LogService } from 'app/lib/log.service';
import { SeriesService } from 'app/lib/series.service';
import { StorageService } from 'app/lib/storage.service';
import { UserService } from 'app/lib/user.service';
import { Reads } from "app/models/course";
import { User } from 'app/models/user';

@Component({
    selector: 'app-series-reads-content',
    templateUrl: './series-reads-content.component.html',
    styleUrl: './series-reads-content.component.scss',
    standalone: false,
})
export class SeriesReadsContentComponent {
    readableSeriesList: Reads[] = [];
    loaded: boolean = false;
    lang: any = 'en';
    categoryList = [];
    user: User;
    categorySelected: number = 0;
    isReadableSeriesloaded: boolean = false;
    filteredReadableSeriesList: Reads[] = [];
    constructor(
        private api: ApiService,
        private storage: StorageService,
        private router: Router,
        private userService: UserService,
        private log: LogService,
        private location: Location,
        private seriesService: SeriesService,
        private translate: TranslateService
    ) {
      this.user = this.userService.getUser();
    }
    // selected = 'option2';

    ngOnInit(): void {
        this.getCategories();
        this.getReadableSeries();
        this.lang = this.translate.currentLang;
    }
    ngDoCheck() {
        this.lang = this.translate.currentLang;
    }

    getCategories() {
        this.seriesService.categories.subscribe(data => {
            this.categoryList = data;
        });
        this.seriesService.getCategories();
    }

    getReadableSeries() {
      this.isReadableSeriesloaded = false;
      this.loaded = false;
        this.seriesService
        .getReadableSeriesList()
        .subscribe(
          (data: any) => {
            if (data && data.length > 0) {
              this.loaded = true;
              this.readableSeriesList = data || [];
              this.getFilteredList();
            }
            this.isReadableSeriesloaded = true;
          },
          (error: any) => {
            this.loaded = true;
                this.log.error(
                    'Error getting read content list. ' + error.message
                );
          },
        );
    }

    getFilteredList() {
        if (this.categorySelected == 0) {
            this.filteredReadableSeriesList = [...this.readableSeriesList];
        } else {
            this.filteredReadableSeriesList = this.readableSeriesList.filter(
              (item) => item.category === this.categorySelected,
            );
        }
    }

    goToRead(reads: any) {
          window.open(reads.fileUrl, '_blank');
          this.log.event(AnalyticEvent.internalPagesEvents.customOrgReadItemClicked, '',
            { title: reads["title" + this.lang] },
          );
          reads?.id && this.seriesService.logReadsSeriesClickCount(reads.id);
    }

    goBack() {
        this.location.back();
    }
}
